import './modals.css';

export const PasswordChangeModal = ({ userEmail, onConfirm, onCancel }) => (
  <div className="password-change-modal-overlay" onClick={onCancel}>
    <div className="password-change-modal" onClick={(e) => e.stopPropagation()}>
      <div className="password-change-modal-icon">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <circle cx="24" cy="24" r="22" stroke="#667eea" strokeWidth="2" fill="rgba(102, 126, 234, 0.1)" />
          <path d="M24 16v12M24 32h.01" stroke="#667eea" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <h2 className="password-change-modal-title">Confirm Email Address</h2>
      <p className="password-change-modal-message">
        The link to reset the password will be sent to this email address:
      </p>
      <p className="password-change-modal-email">{userEmail}</p>
      <p className="password-change-modal-question">Is this correct?</p>
      <div className="password-change-modal-actions">
        <button className="password-change-modal-button-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button className="password-change-modal-button" onClick={onConfirm}>
          Continue
        </button>
      </div>
    </div>
  </div>
);
